import { get } from 'lodash/fp';
import { EngineType } from '../../../../api/types';
import useValidator from '../../../../utilities/useValidator';
import validators from '../../../../utilities/validators';

const validator = validators.compose(
    validators.requiredString('identifier'),
    validators.requiredString('name.defaultValue'),
    validators.requiredValue('modelId'),
    validators.requiredNumber('order'),
    validators.requiredBoolean('isActive'),
    validators.requiredStringEnum('engineType', EngineType),
    validators.requiredNumber('vehiclePrice'),
    validators.only(
        values => !!get('energyConsumption.unit', values),
        validators.requiredNumber('energyConsumption.value')
    ),
    validators.only(
        values => !!get('energyConsumption.value', values),
        validators.requiredString('energyConsumption.unit')
    )
);

const useVariantValidator = () => useValidator(validator);

export default useVariantValidator;
